import { render, staticRenderFns } from "./InputAmount.vue?vue&type=template&id=c196403e"
import script from "./InputAmount.vue?vue&type=script&lang=js"
export * from "./InputAmount.vue?vue&type=script&lang=js"
import style0 from "./InputAmount.vue?vue&type=style&index=0&id=c196403e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports